/**
 * @generated SignedSource<<8ae400a90e372fabfebd1743ea743e54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ImportHubspotCompaniesInput = {
  clientIds?: ReadonlyArray<string | null> | null;
  selectAll?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ImportHubspotCompaniesMutation$variables = {
  input: ImportHubspotCompaniesInput;
};
export type ImportHubspotCompaniesMutation$data = {
  readonly importHubspotCompanies: {
    readonly clients: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly street: string | null;
        readonly zip: string | null;
        readonly city: string | null;
        readonly vat: string | null;
        readonly country: string | null;
        readonly notes: string | null;
        readonly logoId: string | null;
        readonly logoDefaultId: number | null;
      } | null;
    } | null> | null;
  } | null;
};
export type ImportHubspotCompaniesMutation = {
  variables: ImportHubspotCompaniesMutation$variables;
  response: ImportHubspotCompaniesMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImportHubspotCompaniesPayload",
    "kind": "LinkedField",
    "name": "importHubspotCompanies",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientTypeEdge",
        "kind": "LinkedField",
        "name": "clients",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Client",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zip",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoDefaultId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportHubspotCompaniesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportHubspotCompaniesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ccc1c0e6c2a922f666139996cf83bbd6",
    "id": null,
    "metadata": {},
    "name": "ImportHubspotCompaniesMutation",
    "operationKind": "mutation",
    "text": "mutation ImportHubspotCompaniesMutation(\n  $input: ImportHubspotCompaniesInput!\n) {\n  importHubspotCompanies(input: $input) {\n    clients {\n      cursor\n      node {\n        id\n        name\n        street\n        zip\n        city\n        vat\n        country\n        notes\n        logoId\n        logoDefaultId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5240457d3d95a610803051e95cbe955c";

export default node;
